import { t, tr } from "../i18n";
import { $, h } from "../lib/dom";
import { resolve } from "../lib/util";
import { finish } from "./debrief";
import { L, rt, S } from "./state";
import { renderWaits } from "./waits";

/** "HH:MM" for game minute t (defaults to now). */
export function clock(t: number = S.t): string {
  const m = (L.start + t + 1440) % 1440;
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
}

export const idleSecNow = (): number => (L.idleSec !== undefined ? resolve(L.idleSec) : 0) || 12;

const IDLE_REASON = t("time.idle");
let spendTimer: ReturnType<typeof setTimeout> | undefined;

function showSpend(n: number, why: string): void {
  const hud = $("#hudSpend");
  const c = $("#hudClock");
  hud.replaceChildren(h("b", { text: t("time.min", { n }) }), `${t("log.sep")}${why}`);
  hud.style.left = `${c.offsetLeft + c.offsetWidth + 6}px`;
  hud.style.top = `${c.offsetTop}px`;
  hud.style.transform = "none";
  hud.classList.toggle("idle", why === IDLE_REASON);
  hud.classList.add("show");
  clearTimeout(spendTimer);
  spendTimer = setTimeout(() => hud.classList.remove("show"), 1800);
}

/** Advance the game clock n minutes, running the level's per-minute tick. */
export function spend(n: number, why = t("time.action")): void {
  const running = () => S.live && !S.ended && !S.ending;
  if (n > 0 && running()) showSpend(n, why);
  for (let i = 0; i < n && running(); i++) {
    S.t++;
    L.tick(S.t);
    if (running() && S.t >= (L.maxT ?? 75)) {
      if (L.timeup) L.timeup();
      else void finish(t("time.up"));
      break;
    }
  }
  renderHUD();
  renderWaits();
}

export function renderHUD(): void {
  if (!S.live) return;
  const c = $("#hudClock");
  c.textContent = clock();
  c.classList.toggle("warn", !!L.urgent?.());
  $("#hudVit").replaceChildren(
    ...L.hud().map(([lab, val]) => h("div", {}, h("span", { className: "t", text: lab + tr("　", " ") }), val)),
  );
  $("#finishBtn").hidden = !(S.canEnd && !S.ended && !S.ending);
}

const overlayOpen = (id: string): boolean => $(id).classList.contains("show");

/** One real second → maybe one idle game minute. Paused while busy, in cutscenes, or behind overlays. */
export function startIdleClock(): void {
  setInterval(() => {
    if (!S.live || !S.started || S.ended) return;
    renderWaits();
    if (
      S.busy ||
      S.cine ||
      document.hidden ||
      overlayOpen("#call") ||
      overlayOpen("#help") ||
      performance.now() < S.pauseUntil
    )
      return;
    rt.idle++;
    if (rt.idle >= idleSecNow()) {
      rt.idle = 0;
      spend(1, IDLE_REASON);
    }
  }, 1000);
}
